import React from 'react';
import { ChevronDown } from 'lucide-react';
import { brandData } from '../data/mock';

export const HeroSection = () => {
  const scrollToBrands = () => {
    const element = document.getElementById('brands');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section relative min-h-screen flex items-center justify-center">
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 py-32 text-center">
        {/* Main Logo */}
        <div className="mb-12 animate-fade-in-up">
          <img 
            src={brandData.mainBrand.logo}
            alt="DRM Kitchen Logo"
            className="w-40 h-40 md:w-52 md:h-52 mx-auto object-contain"
          />
        </div>

        {/* Elegant Line */}
        <div className="w-24 h-px bg-[#c9a962] mx-auto mb-10 animate-fade-in-up delay-100"></div>

        {/* Tagline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-[#1a1a1a] mb-6 animate-fade-in-up delay-200 tracking-wide">
          {brandData.mainBrand.tagline}
        </h1>

        {/* Subtitle */}
        <p className="text-base md:text-lg text-[#8a8a8a] mb-12 animate-fade-in-up delay-300 max-w-xl mx-auto font-light leading-relaxed">
          Geleneksel lezzetlerden modern yorumlara, yedi benzersiz marka ile 
          damak zevkinize hitap ediyoruz.
        </p>

        {/* CTA */}
        <div className="animate-fade-in-up delay-400">
          <button 
            onClick={scrollToBrands}
            className="elegant-btn inline-flex items-center gap-3 px-10 py-4 bg-[#1a1a1a] text-white text-sm tracking-widest uppercase hover:bg-[#2d2d2d] transition-colors"
          >
            Markalarımız
          </button>
        </div>

        {/* Brand Count */}
        <div className="mt-20 animate-fade-in-up delay-500">
          <div className="flex items-center justify-center gap-4">
            <div className="w-16 h-px bg-[#c9a962]/30"></div>
            <span className="text-sm tracking-widest uppercase text-[#8a8a8a]">7 Özel Marka</span>
            <div className="w-16 h-px bg-[#c9a962]/30"></div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
          <button 
            onClick={scrollToBrands}
            className="text-[#c9a962] hover:text-[#a68b4b] transition-colors"
          >
            <ChevronDown size={28} strokeWidth={1} />
          </button>
        </div>
      </div>
    </section>
  );
};
